import { useEffect, useState } from "react";
import { BoardScreen } from "./screens/Board";
import { MenuScreen } from "./screens/Menu";
import { OrderScreen } from "./screens/Order";

/**
 * Два экрана и никакой библиотеки роутинга: меню открывается по ссылке
 * из QR-наклейки, страница заказа — по персональному токену.
 */
function readRoute() {
  const path = window.location.pathname;

  /*
   * Экран выдачи живёт на своём поддомене — а на точке, где поддоменов нет,
   * на своём пути. Телевизор открывает адрес с кодом один раз и живёт с ним
   * месяцами. Код остаётся в ссылке: он и есть ключ доступа.
   */
  const onBoardHost = window.location.hostname.toLowerCase().split(".")[0] === "board";
  const onBoardPath = path === "/board" || path.startsWith("/board/");

  if (onBoardHost || onBoardPath) {
    return { screen: "board" as const, code: new URLSearchParams(window.location.search).get("code") ?? "" };
  }

  const order = path.match(/^\/order\/([^/]+)\/?$/);
  if (order) return { screen: "order" as const, token: decodeURIComponent(order[1]!) };

  // Старый адрес страницы заказа: ссылки могли остаться в переписке.
  const legacyToken = new URLSearchParams(window.location.search).get("token");
  if (path === "/order.html" && legacyToken) return { screen: "order" as const, token: legacyToken };

  const bench = path.match(/^\/b\/([^/]+)\/?$/);
  const benchRef = bench
    ? decodeURIComponent(bench[1]!)
    : new URLSearchParams(window.location.search).get("bench") ?? "";

  return { screen: "menu" as const, benchRef };
}

export function App() {
  const [route, setRoute] = useState(readRoute);

  useEffect(() => {
    const onPop = () => setRoute(readRoute());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  if (route.screen === "board") return <BoardScreen code={route.code} />;
  if (route.screen === "order") return <OrderScreen token={route.token} />;
  return <MenuScreen benchRef={route.benchRef} />;
}
